type NullableString = { String: string; Valid: boolean };
type NullableInt64 = { Int64: number; Valid: boolean };

export function textOf(v: unknown): string {
  if (v == null) {
    return '';
  }
  if (
    typeof v === 'string' ||
    typeof v === 'number' ||
    typeof v === 'boolean'
  ) {
    return String(v);
  }

  if (typeof v === 'object') {
    if ('String' in v) {
      return String((v as NullableString).String ?? '');
    }
    if ('VALUE' in v) {
      return String((v as ANY).VALUE ?? '');
    }
    if ('value' in v) {
      return String((v as ANY).value ?? '');
    }
  }
  return '';
}

export function intOf(v: unknown): number {
  const n = Number(v);
  if (Number.isFinite(n)) {
    return n;
  }

  if (v && typeof v === 'object' && 'Int64' in v) {
    const x = Number((v as NullableInt64).Int64);
    return Number.isFinite(x) ? x : 0;
  }
  return 0;
}
